const STAFF_ROLES = new Set(['admin', 'manager', 'supervisor']);

export const DIRECT_ORDER_REP_LABEL = 'Direct Order';

/** True when the logged-in user should own new orders (field rep, not back-office staff). */
export function shouldDefaultOrderRepToSelf(user) {
  if (!user?.id) return false;
  const role = String(user.role || '').toLowerCase();
  return !STAFF_ROLES.has(role);
}

/** @deprecated alias */
export function isRepUser(user) {
  return shouldDefaultOrderRepToSelf(user);
}

export function getDefaultOrderRepId(user, reps = []) {
  if (shouldDefaultOrderRepToSelf(user)) {
    return String(user.id);
  }
  const direct = findDirectOrderRep(reps);
  return direct?.id != null ? String(direct.id) : '';
}

/** Rep id sent to API — form value, else field rep self or Direct Order for staff. */
export function resolveOrderRepId(user, formRepId, reps = []) {
  const parsed = parseInt(formRepId, 10);
  if (Number.isFinite(parsed) && parsed > 0) return parsed;
  const fallback = parseInt(getDefaultOrderRepId(user, reps), 10);
  return Number.isFinite(fallback) && fallback > 0 ? fallback : null;
}

export function selfRepOption(user) {
  if (!shouldDefaultOrderRepToSelf(user) || !user?.id) return null;
  return {
    id: user.id,
    name: user.name || user.email?.split('@')[0] || `Rep #${user.id}`,
  };
}

export function findDirectOrderRep(reps = []) {
  return reps.find(isDirectOrderRep) || null;
}

export function isDirectOrderRep(rep) {
  return (
    rep?.is_direct_order
    || String(rep?.name || '').trim().toLowerCase() === DIRECT_ORDER_REP_LABEL.toLowerCase()
  );
}

/** Rep dropdown options: Direct Order first, then reps A–Z (field rep self included in sort). */
export function buildOrderRepOptions(reps, user) {
  const raw = [...(reps || [])];
  const self = selfRepOption(user);
  if (self && !raw.some((r) => String(r.id) === String(self.id))) {
    raw.push(self);
  }

  const direct = raw.find(isDirectOrderRep) || null;
  const others = raw
    .filter((r) => !isDirectOrderRep(r))
    .sort((a, b) =>
      String(a.name || '').localeCompare(String(b.name || ''), 'en', { sensitivity: 'base' })
    );

  return direct ? [direct, ...others] : others;
}

/** Display name for an order's sales rep row. */
export function resolveOrderRepName(order, reps = []) {
  if (order?.rep_name) return order.rep_name;
  const match = reps.find((r) => String(r.id) === String(order?.rep_id));
  if (match?.name) return match.name;
  if (match?.is_direct_order) return DIRECT_ORDER_REP_LABEL;
  if (order?.rep_id == null) return DIRECT_ORDER_REP_LABEL;
  return '-';
}
